import styled from 'styled-components';
import colors from 'themes/Main';

const { white, gray01 } = colors;

export const RadioContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: ${({ position }) => (position === 'top' ? 'column' : 'row')};
  margin-bottom: 8px;

  .RadioButton {
    min-width: 18px;
    min-height: 18px;
    height: 18px;
    width: 18px;
    display: block;
    border: 1.5px solid ${gray01};
    border-radius: 100px;
    margin: 8px;
    padding: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const RadioButton = styled.label`
  min-width: 20px;
  min-height: 20px;
`;

export const Radio = styled.input.attrs({
  type: 'radio',
})`
  display: none;

  ${({ checked }) =>
    checked &&
    `
    ~ .RadioButton::before {
        content: '';
        min-width: 18px;
        min-height: 18px;
        background: ${white};
        border-width: 6px;
        border-color: ${gray01};
        border-style:  solid;
        border-radius: 50px;
        display: block;
        position: absolute;
      }
  `}
`;
export const Label = styled.label`
  margin-bottom: 0;
  margin-left: ${({ position }) => (position === 'right' ? '8px' : '')};
  margin-top: ${({ position }) => (position === 'top' ? '8px' : '')};
`;
